var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGuideBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49976 5.00012C3.49976 3.34327 4.8429 2.00012 6.49976 2.00012H21.4998C23.1566 2.00012 24.4998 3.34327 24.4998 5.00012V21.0001L18.7779 25.7683C18.5982 25.9181 18.3716 26.0001 18.1377 26.0001H5.99976C4.61904 26.0001 3.49976 24.8808 3.49976 23.5001V5.00012Z",
    fill: "#FFD633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 14.8615C13.1748 14.8615 12.5047 15.5321 12.5047 16.3593C12.5047 17.1865 13.1748 17.8571 14.0013 17.8571C14.8279 17.8571 15.498 17.1865 15.498 16.3593C15.498 15.5321 14.8279 14.8615 14.0013 14.8615ZM13.9981 5C13.2296 5.00028 12.5963 5.57951 12.51 6.32547L12.5 6.50038L12.5027 11.8581L12.5128 12.033C12.5997 12.7789 13.2333 13.3576 14.0019 13.3574C14.7704 13.3571 15.4037 12.7779 15.49 12.0319L15.5 11.857L15.4973 6.4993L15.4872 6.32439C15.4003 5.57849 14.7667 4.99972 13.9981 5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49976 23.5001C3.49976 22.1194 4.61904 21.0001 5.99976 21.0001H24.4998C24.4998 21.0001 23.9998 21.7501 23.9998 23.2501C23.9998 24.0562 24.1441 24.79 24.2777 25.2965C24.3679 25.6385 24.115 26.0001 23.7612 26.0001H5.99976C4.61904 26.0001 3.49976 24.8808 3.49976 23.5001Z",
    fill: "#D29700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuideBook);
export default __webpack_public_path__ + "static/media/icon-guide-book.0d5dc045a4ad9327fc5667949bc67b53.svg";
export { ForwardRef as ReactComponent };